import React, { Component } from "react";
import { message } from "@cloud/atom-ui";
import PlusOutlined from "@cloud/atom-ui-icons/PlusOutlined";
import Corpers from "./coroperModal";
import "./avatar.less";
import {urlDomainDeal} from "@src/utils/common";

export default class PicturesWall extends Component {
  state = {
    cropVisible: false,
    cropSrc: "",
    imgUrl: this.props.item.value || "",
    oldImgUrl: "",
    files: [],
    isOpen: false,
    showModal: false,
    imgSrc: "",
    index: 0,
    imgList: [
      require("@src/assets/mm.png"),
      require("@src/assets/11.png"),
      require("@src/assets/12.png"),
      require("@src/assets/22.png"),
    ],
    tabIndex: 1,
    checkedId: "",
    imgsList: [
      { id: 0, img: require("@src/assets/avatar1.png") },
      { id: 1, img: require("@src/assets/avatar2.png") },
      { id: 2, img: require("@src/assets/avatar3.png") },
      { id: 3, img: require("@src/assets/avatar4.png") },
      { id: 4, img: require("@src/assets/avatar5.png") },
      { id: 5, img: require("@src/assets/avatar6.png") },
    ],
    defaultImgList: [
      {
        id: 0,
        img: require("@src/assets/avatar1.png"),
      },
      {
        id: 1,
        img: require("@src/assets/avatar2.png"),
      },
      {
        id: 2,
        img: require("@src/assets/avatar3.png"),
      },
      {
        id: 3,
        img: require("@src/assets/avatar4.png"),
      },
      {
        id: 4,
        img: require("@src/assets/avatar5.png"),
      },
      {
        id: 5,
        img: require("@src/assets/avatar6.png"),
      },
      {
        id: 6,
        img: require("@src/assets/avatar7.png"),
      },
      {
        id: 7,
        img: require("@src/assets/avatar8.png"),
      },
      {
        id: 8,
        img: require("@src/assets/avatar9.png"),
      },
      {
        id: 9,
        img: require("@src/assets/avatar10.png"),
      },
      {
        id: 10,
        img: require("@src/assets/avatar11.png"),
      },
      {
        id: 11,
        img: require("@src/assets/avatar12.png"),
      },
      {
        id: 12,
        img: require("@src/assets/avatar13.png"),
      },
      {
        id: 13,
        img: require("@src/assets/avatar14.png"),
      },
      {
        id: 14,
        img: require("@src/assets/avatar15.png"),
      },
      {
        id: 15,
        img: require("@src/assets/avatar16.png"),
      },
      {
        id: 16,
        img: require("@src/assets/avatar17.png"),
      },
    ],
  };

  timeOutId = null;

  static getDerivedStateFromProps(props, state) {
    if (props?.item?.value !== state.oldImgUrl) {
      return {
        imgUrl: props.item.value,
        oldImgUrl: props.item.value,
      };
    }
    return null;
  }

  getBase64 = (img) => {
    const reader = new FileReader();
    reader.readAsDataURL(img);
    reader.onload = () => {
      this.setState({
        cropSrc: reader.result,
        cropVisible: true,
      });
    };
  };
  beforeUpload = (file) => {
    let isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("仅支持JPG或PNG格式");
      return (isJpgOrPng = Promise.reject());
    }
    let isLt2M = file.size / 1024 < 10000000;
    if (!isLt2M) {
      message.error("上传文件大小不能超过100KB");
      return (isLt2M = Promise.reject());
    }
    const isSize = new Promise((resolve, reject) => {
      let IMG = new Image();
      let _URL = window.URL || window.webkitURL;
      IMG.src = _URL.createObjectURL(file);
      let valid;
      IMG.onload = () => {
        valid = true;
        valid ? resolve() : reject();
      };
    }).then(
      () => file,
      () => {
        message.error("IMG should 984 * 2000");
        return Promise.reject();
      }
    );
    return isJpgOrPng && isLt2M && isSize;
  };
  pen1 = () => {
    this.textInput.click();
  };

  changePic = async (event) => {
    event.persist();
    let files = event.target.files;
    for (let i = 0; i < files.length; i++) {
      let img = await this.beforeUpload(files[i]);
      this.getBase64(img);
    }
    event.target.value = "";
  };

  handleOk = (imgUrl) => {
    if (imgUrl) {
      let arr = imgUrl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      let dataFile = new Blob([u8arr]);
      let formData = new FormData();
      formData.append("file0", dataFile, "1.png");
      this.setState({});
      fetch(
        `/${process.env.REACT_APP_API_CONTEXT}/service/myAppService/uploadImage?type=icon`,
        {
          method: "POST",
          body: formData,
        }
      ).then((data) => {
        if (data.status == 1) {
          let result = (data && data.data) || {};
          this.props.change(result);
          let imgsList = this.state.imgsList;
          let allList = this.state.defaultImgList;
          imgsList.forEach((item) => {
            item.checked = false;
          });
          allList.forEach((item) => {
            item.checked = false;
          });
          this.setState({
            imgsList: imgsList,
            defaultImgList: allList,
            checkedId: "",
            imgUrl: imgUrl,
          });
        } else {
          message.error(data.errMsg || "图片上传失败", 2);
          this.setState({});
        }
      }).catch((e) => {
        message.error(data.errMsg || "图片上传失败", 2);
        this.setState({});
      });
    }
    this.setState({
      cropVisible: false,
    });
  };

  imgError = () => { };

  tabChange = (index) => {
    let allList = this.state.defaultImgList;
    let imgsList = allList.slice(index * 6 - 6, index * 6);
    this.setState({
      imgsList: imgsList,
      tabIndex: index,
    });
  };

  imgChecked = (id, img) => {
    let imgsList = this.state.imgsList;
    let allList = this.state.defaultImgList;
    imgsList.forEach((item) => {
      if (item.id == id) {
        item.checked = true;
      } else {
        item.checked = false;
      }
    });
    allList.forEach((item) => {
      if (item.id == id) {
        item.checked = true;
      } else {
        item.checked = false;
      }
    });
    this.setState({
      imgsList: imgsList,
      defaultImgList: allList,
      checkedId: id,
      imgUrl: img,
    });
    this.props.change(img);
  };

  render() {
    const { imgUrl, cropVisible, cropSrc, files } = this.state;
    const { item } = this.props;
    const { isEdit } = item;
    return (
      <>
        <div className="pic-wall-avatar">
          {isEdit ? (
            <>
              <div className="picture-list" style={{ marginLeft: "-10px" }}>
                {files.length >= 10 ? null : (
                  <div
                    className={
                      imgUrl
                        ? "file-upload-select img-upload-select"
                        : "file-upload-select"
                    }
                    onClick={this.pen1}
                    style={{
                      padding: imgUrl ? "0" : "23px",
                      position: "relative",
                    }}
                  >
                    <span className="file-upload" role="button">
                      {imgUrl ? (
                        <img
                          style={{
                            width: "78px",
                            height: "78px",
                            borderRadius: "23.4px",
                          }}
                          src={urlDomainDeal(imgUrl)}
                          alt=""
                        />
                      ) : (
                        <>
                          <PlusOutlined style={{ color: '#dedede', fontSize: '18px' }} />
                          <div style={{ color: '#999', fontSize: '12px' }}>上传</div>
                        </>
                      )}

                      <input
                        ref={(input) => (this.textInput = input)}
                        onChange={this.changePic}
                        type="file"
                        accept=""
                        style={{ display: "none" }}
                      />
                    </span>
                    {imgUrl && <div className="change-img">更换图片</div>}
                  </div>
                )}
              </div>
              <div className="defaultIconList" style={{ marginLeft: "-10px" }}>
                <div className="iconTab">
                  <p
                    onClick={() => this.tabChange(1)}
                    className={this.state.tabIndex == 1 ? "tab active" : "tab"}
                  >
                    行政服务
                  </p>
                  <p
                    onClick={() => this.tabChange(2)}
                    className={this.state.tabIndex == 2 ? "tab active" : "tab"}
                  >
                    企业办公
                  </p>
                  <p
                    onClick={() => this.tabChange(3)}
                    className={this.state.tabIndex == 3 ? "tab active" : "tab"}
                  >
                    其他图标
                  </p>
                </div>
                <div className="iconList">
                  <ul>
                    <li className="iconItem">
                      <p>推荐</p>
                    </li>

                    {this.state.imgsList.map((item, index) => {
                      return (
                        <li
                          key={item.id}
                          className={
                            item.checked ? "iconItem itemChecked" : "iconItem"
                          }
                          onClick={() => {
                            this.imgChecked(item.id, item.img);
                          }}
                        >
                          <img src={item.img} />
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </>
          ) : (
            imgUrl && (
              <img
                className="avatar-img-read"
                src={urlDomainDeal(imgUrl)}
                onError={this.imgError}
                alt=""
              />
            )
          )}
          <div>
            {cropVisible && (
              <Corpers
                src={urlDomainDeal(cropSrc)}
                cropVisible={cropVisible}
                handleOk={this.handleOk}
              ></Corpers>
            )}
          </div>
        </div>
      </>
    );
  }
}
